import { render, staticRenderFns } from "./HMChip.vue?vue&type=template&id=2857f961&scoped=true&"
import script from "./HMChip.vue?vue&type=script&lang=js&"
export * from "./HMChip.vue?vue&type=script&lang=js&"
import style0 from "./HMChip.vue?vue&type=style&index=0&id=2857f961&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2857f961",
  null
  
)

export default component.exports